import { FunctionOverrideKey } from "@keepeek/commons";

import { getCustomerOverrideFunction } from "../../lib/overrides";

export const useInitCustomerEvents = () => {
  // Retrieve events enabled in customers
  const enableCustomNavigationEvent = getCustomerOverrideFunction(
    FunctionOverrideKey.EnableCustomNavigationEvent,
    {},
  );

  return {
    enableCustomNavigationEvent,
  };
};
